import { Injectable } from '@angular/core';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDate | null {
    if (!value) return null;
    const parts = value.split('/');
    if (parts.length === 3) {
      const day = Number.parseInt(parts[0], 10);
      const month = Number.parseInt(parts[1], 10);
      const year = Number.parseInt(parts[2], 10);
      if (!Number.isNaN(day) && !Number.isNaN(month) && !Number.isNaN(year)) {
        return new NgbDate(year, month, day);
      }
    }
    return null;
  }

  format(date: NgbDate | null): string {
    if (!date) return '';
    return `${date.day.toString().padStart(2, '0')}/${date.month
      .toString()
      .padStart(2, '0')}/${date.year}`;
  }
}
